import styled from 'styled-components';
import UnstyledCard from '../../../../components/Card';
import UnstyledTitle from '../../../../components/Title';
import UnstyledButton from '../../../../components/Button';

export const Card = styled(UnstyledCard)`
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  & > * {
    text-align: center;
    margin: 0 auto;
  }

  & > *:first-child {
    margin-bottom: 20px;
  }

  & > *:last-child {
    margin-bottom: 10px;
  }
`;

export const Section = styled.div`
  padding: 25px;
`;

export const Title = styled(UnstyledTitle)`
  margin-top: 25px;
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;

  ${({ theme }) => theme.media.tabletPortraitUp`
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
  `}
`;

export const DateRangeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${({ theme }) => theme.media.tabletPortraitUp`
    flex-direction: row;
    align-items: flex-end;
    gap: 15px;
  `}
`;

export const DetailsCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const DetailRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border || '#e0e0e0'};

  ${({ theme }) => theme.media.tabletPortraitUp`
    flex-direction: row;
    align-items: center;
  `}

  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.span`
  font-weight: 600;
  min-width: 150px;
  color: ${({ theme }) => theme.colors.textSecondary || '#666'};
`;

export const DetailValue = styled.span`
  color: ${({ theme }) => theme.colors.text || '#333'};
`;

export const TypeBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${({ $type, theme }) => {
    if ($type === 'external_funding_account') return theme.colors.success || '#28a745';
    if ($type === 'external_source_account') return theme.colors.info || '#17a2b8';
    return theme.colors.secondary || '#6c757d';
  }};
  color: white;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;

  ${({ theme }) => theme.media.tabletPortraitUp`
    flex-direction: row;
    justify-content: flex-start;
  `}
`;

export const BackButton = styled(UnstyledButton)`
  width: auto;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0px;
  min-width: 150px;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${({ $status, theme }) => {
    switch ($status) {
    case 'awaiting_settlement':
    case 'pending':
      return theme.colors.warning || '#ffc107';
    case 'completed':
    case 'approved':
    case 'settled':
      return theme.colors.success || '#28a745';
    case 'cancelled':
    case 'declined':
    case 'error':
    case 'failed':
    case 'rejected':
      return theme.colors.danger || '#dc3545';
    case 'processing':
    case 'in_progress':
      return theme.colors.info || '#17a2b8';
    case 'expired':
    case 'refunded':
      return theme.colors.secondary || '#6c757d';
    default:
      return theme.colors.secondary || '#6c757d';
    }
  }};
  color: ${({ $status }) => {
    if ($status === 'awaiting_settlement' || $status === 'pending') return '#333';
    return 'white';
  }};
`;
